import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export default function VerifyCodePage() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); 
    try {
      const API_BASE_URL = process.env.REACT_APP_API_URL;
      const res = await axios.post(
        `${API_BASE_URL}/auth/verify-second-password`,
        {
          code: code,
        }
      );

      localStorage.setItem("secondAuthToken", res.data.secondAuthToken);
      navigate("/"); 
    } catch (err) {
      toast.error("Code de validation incorrect !");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
      <h1 className="text-2xl font-bold mb-4">Code de validation</h1>
      <form onSubmit={handleSubmit} className="space-y-4 w-full max-w-sm">
        <input
          type="password"
          placeholder="Entrez le mot de passe secondaire"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="w-full px-4 py-2 border rounded"
        />
        <button
          type="submit"
          className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700"
        >
          Valider
        </button>
      </form>
    </div>
  );
}
